import { englishType } from 'types'

export const lesson15: englishType[] = [
  {
    id: 1,
    word: "amusement park",
    meaning: ["놀이공원"]
  }, {
    id: 2,
    word: "annually",
    meaning: ["해마다", "일년에 한 번"]
  }, {
    id: 3,
    word: "antelope",
    meaning: ["영양"]
  }, {
    id: 4,
    word: "arch",
    meaning: ["아치"]
  }, {
    id: 5,
    word: "artificial",
    meaning: ["인공의"]
  }, {
    id: 6,
    word: "atmosphere",
    meaning: ["대기", "공기"]
  }, {
    id: 7,
    word: "carbon",
    meaning: ["탄소"]
  }, {
    id: 8,
    word: "collapse",
    meaning: ["붕괴하다"]
  }, {
    id: 9,
    word: "convenient",
    meaning: ["편리한"]
  }, {
    id: 10,
    word: "critical",
    meaning: ["위기의", "심각한", "위태로운", "비판적인"]
  }, {
    id: 11,
    word: "destroy",
    meaning: ["파괴하다"]
  }, {
    id: 12,
    word: "dinosaur",
    meaning: ["공룡"]
  }, {
    id: 13,
    word: "diversity",
    meaning: ["다양성"]
  }, {
    id: 14,
    word: "donate",
    meaning: ["기부하다", "기증하다", "후원하다"]
  }, {
    id: 15,
    word: "ecosystem",
    meaning: ["생태계"]
  }, {
    id: 16,
    word: "endangered",
    meaning: ["멸종 위기에 처한"]
  }, {
    id: 17,
    word: "essential",
    meaning: ["필수적인"]
  }, {
    id: 18,
    word: "fine dust",
    meaning: ["미세 먼지"]
  }, {
    id: 19,
    word: "fossil fuel",
    meaning: ["화석 연료"]
  }, {
    id: 20,
    word: "garbage",
    meaning: ["쓰레기"]
  }, {
    id: 21,
    word: "grocery store",
    meaning: ["식료품점"]
  }, {
    id: 22,
    word: "hyena",
    meaning: ["하이에나"]
  }, {
    id: 23,
    word: "indifferent",
    meaning: ["무관심한"]
  }, {
    id: 24,
    word: "inspire",
    meaning: ["영감을 주다"]
  }, {
    id: 25,
    word: "inspiration",
    meaning: ["영감"]
  }, {
    id: 26,
    word: "landfill",
    meaning: ["매립지", "쓰레기 매립지"]
  }, {
    id: 27,
    word: "lung",
    meaning: ["폐"]
  }, {
    id: 28,
    word: "maintain",
    meaning: ["유지하다"]
  }, {
    id: 29,
    word: "marine",
    meaning: ["해양의", "바다의"]
  }, {
    id: 30,
    word: "migrate",
    meaning: ["이주하다", "이동하다", "옮기다"]
  }, {
    id: 31,
    word: "mussel",
    meaning: ["홍합", "담치"]
  }, {
    id: 32,
    word: "nutrient",
    meaning: ["영양소", "영양분"]
  }, {
    id: 33,
    word: "observe",
    meaning: ["관찰하다"]
  }, {
    id: 34,
    word: "period",
    meaning: ["기간", "시대", "시기", "주기"]
  }, {
    id: 35,
    word: "plain",
    meaning: ["평야", "초원"]
  }, {
    id: 36,
    word: "pollution",
    meaning: ["오염"]
  }, {
    id: 37,
    word: "predator",
    meaning: ["포식자", "육식동물"]
  }, {
    id: 38,
    word: "professor",
    meaning: ["교수"]
  }, {
    id: 39,
    word: "public awareness",
    meaning: ["대중의 인식"]
  }, {
    id: 40,
    word: "rapidly",
    meaning: ["재빨리", "신속히"]
  }, {
    id: 41,
    word: "recovery",
    meaning: ["회복", "되찾음"]
  }, {
    id: 42,
    word: "recycle",
    meaning: ["재활용하다"]
  }, {
    id: 43,
    word: "remove",
    meaning: ["제거하다", "삭제하다", "치우다"]
  }, {
    id: 44,
    word: "relieved",
    meaning: ["안도하는", "다행으로 여기는"]
  }, {
    id: 45,
    word: "rewarding",
    meaning: ["가치가 있는", "보람 있는"]
  }, {
    id: 46,
    word: "shelter",
    meaning: ["피난처", "대피소", "보호소"]
  }, {
    id: 47,
    word: "significantly",
    meaning: ["중대하게"]
  }, {
    id: 48,
    word: "spread",
    meaning: ["흩뿌리다", "펼치다", "확산시키다", "퍼트리다"]
  }, {
    id: 49,
    word: "term",
    meaning: ["용어", "학기", "기간"]
  }, {
    id: 50,
    word: "toxic",
    meaning: ["독성의", "독극물의", "유독성의"]
  }, {
    id: 51,
    word: "zoology",
    meaning: ["동물학"]
  }, {
    id: 52,
    word: "especially",
    meaning: ["특히", "특별히", "유난히"]
  }, {
    id: 53,
    word: "encourage",
    meaning: ["격려하다", "부추기다", "권장하다"]
  }, {
    id: 54,
    word: "expert",
    meaning: ["전문가", "전문가의"]
  }, {
    id: 55,
    word: "expertise",
    meaning: ["전문 지식", "전문 분야"]
  }, {
    id: 56,
    word: "discuss",
    meaning: ["상의하다", "논의하다", "논하다", "의논하다", "토론하다"]
  }, {
    id: 57,
    word: "keystone",
    meaning: ["쐬기돌", "핵심"]
  }, {
    id: 58,
    word: "species",
    meaning: ["종"]
  }, {
    id: 59,
    word: "preys",
    meaning: ["먹이"]
  }, {
    id: 60,
    word: "focus on",
    meaning: ["~에 집중하다", "~에 주력하다", "~에 초점을 맞추다"]
  }, {
    id: 61,
    word: "Not only A but also B",
    meaning: ["A뿐만 아니라 B도"]
  }, {
    id: 62,
    word: "antelope",
    meaning: ["영양"]
  }, {
    id: 63,
    word: "balance",
    meaning: ["균형"]
  }, {
    id: 64,
    word: "particular",
    meaning: ["특정한"]
  }, {
    id: 65,
    word: "pleasure",
    meaning: ["기쁨", "재미", "즐거움", "기쁜 일"]
  }, {
    id: 66,
    word: "protect",
    meaning: ["보호하다", "보장하다"]
  }, {
    id: 67,
    word: "prevent",
    meaning: ["막다", "예방하다"]
  }, {
    id: 68,
    word: "disturb",
    meaning: ["방해하다", "교란시키다", "교란하다", "건드리다", "불안하게 하다"]
  }, {
    id: 69,
    word: "identified",
    meaning: ["확인된", "인정된", "식별된"]
  }, {
    id: 70,
    word: "declining",
    meaning: ["쇠퇴하는", "소멸되는", "감소하는"]
  }, {
    id: 71,
    word: "be worried about A",
    meaning: ["A에 대해 걱정되다", "A가 걱정되다"]
  }, {
    id: 72,
    word: "be important to A",
    meaning: ["A하는 것이 중요하다", "A하는 게 중요하다"]
  },
]
